import React from 'react';
import ProductDetails from '../components/products/productDetails';
import ProductSlider from '../components/products/productslider';




const ProductDetailsPage = () => {
    return (
        <div>


            <ProductDetails />
            <ProductSlider />

        </div>
    );
}

export default ProductDetailsPage;
